export const textBodyElement = "textBody";
export const divElement = "div";
